import React from 'react';
import {Alert, Button} from "react-bootstrap";
import CustomButton from "./button";
import {CheckWhiteIcon} from "../assets";
import {Link} from "react-router-dom";
import {PATH_APP} from "../routes/paths";

function SubmitWeight(props) {
    const measurementAlertColor = days => {
        switch (true) {
            case (days <= 3):
                return "danger";
            case (days <= 7):
                return "warning";
            default:
                return "success";
        }
    };

    return (
        <div>
            {
                (props.remainedDays <= 0) ?
                    <Link to={PATH_APP.weightProcess} id="submit-weight">
                        <CheckWhiteIcon/>
                        ثبت وزن
                    </Link>
                    : <p className={'custom-alert ' + measurementAlertColor(props.remainedDays)}>
                        <svg style={{
                            marginLeft: '10px'
                        }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM9.25 6C9.25 5.59 9.59 5.25 10 5.25C10.41 5.25 10.75 5.59 10.75 6V11C10.75 11.41 10.41 11.75 10 11.75C9.59 11.75 9.25 11.41 9.25 11V6ZM10.92 14.38C10.87 14.51 10.8 14.61 10.71 14.71C10.61 14.8 10.5 14.87 10.38 14.92C10.26 14.97 10.13 15 10 15C9.87 15 9.74 14.97 9.62 14.92C9.5 14.87 9.39 14.8 9.29 14.71C9.2 14.61 9.13 14.51 9.08 14.38C9.03 14.26 9 14.13 9 14C9 13.87 9.03 13.74 9.08 13.62C9.13 13.5 9.2 13.39 9.29 13.29C9.39 13.2 9.5 13.13 9.62 13.08C9.86 12.98 10.14 12.98 10.38 13.08C10.5 13.13 10.61 13.2 10.71 13.29C10.8 13.39 10.87 13.5 10.92 13.62C10.97 13.74 11 13.87 11 14C11 14.13 10.97 14.26 10.92 14.38Z"
                                fill="white"/>
                        </svg>

                        <span dir="ltr">
                        {props.remainedDays}
                     </span>
                        روز مانده تا وزن کشی
                    </p>
            }

        </div>
    );
}

export default SubmitWeight;
